/**
 * Event snippet for Submit lead form (1) conversion page
 * Conversion ID: AW-18475915724 / AynZCMKbpZodEMyzgOpE
 */
function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  try {
    if (typeof gtag === 'function') {
      gtag('event', 'conversion', {
        'send_to': 'AW-18475915724/AynZCMKbpZodEMyzgOpE',
        'event_callback': callback
      });
    } else if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18475915724/AynZCMKbpZodEMyzgOpE',
        'event_callback': callback
      });
    } else if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push('event', 'conversion', {
        'send_to': 'AW-18475915724/AynZCMKbpZodEMyzgOpE',
        'event_callback': callback
      });
      setTimeout(callback, 500);
    } else {
      callback();
    }
  } catch (err) {
    console.error('gtag_report_conversion error:', err);
    callback();
  }
  return false;
}

window.gtag_report_conversion = gtag_report_conversion;
